var React = require('react');

function CartWish (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.77139 6.73458C0.400033 4.90611 0.857151 2.1634 3.14274 1.24917C5.42833 0.334932 6.79968 2.1634 7.2568 3.07764C7.71392 2.1634 9.54239 0.334932 11.828 1.24917C14.1136 2.1634 14.1136 4.90611 12.7422 6.73458C11.3709 8.56306 7.2568 12.22 7.2568 12.22C7.2568 12.22 3.14274 8.56306 1.77139 6.73458Z","stroke":"#10642F","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CartWish.defaultProps = {"width":"15","height":"14","viewBox":"0 0 15 14","fill":"none"};

module.exports = CartWish;

CartWish.default = CartWish;
